import { __awaiter, __generator } from "tslib";
import types from '../../state/types';
import config from '../../constants/unread-chatroom-count-config';
import { getFilteredUnreadChatroomsIds } from '../../state/reducer/selector.chatrooms';
import { isChatroomUnread } from './selector.unread-chatroom-count';
import { parseUnreadFilter } from './reducer.unread-chatroom-count';
import _union from 'lodash/union';
var mergeUnreads = function (unreadChatrooms, state, filter) {
    var unreadChatroomIdsInState = unreadChatrooms.chatroomIds.filter(function (chatroomId) {
        var chatroom = state.chatrooms.byId[chatroomId];
        if (!chatroom) {
            return true;
        }
        return isChatroomUnread(chatroom);
    });
    return _union(unreadChatroomIdsInState, getFilteredUnreadChatroomsIds(state, filter));
};
var shouldResync = function (prevState, newState) {
    return prevState && newState
        && 'resyncCountdown' in prevState
        && 'resyncCountdown' in newState
        && prevState.resyncCountdown === 1
        && newState.resyncCountdown === 0;
};
var UnreadChatroomCountActions = /** @class */ (function () {
    function UnreadChatroomCountActions(serverApi) {
        this.serverApi = serverApi;
    }
    UnreadChatroomCountActions.prototype.fetchAndUpdateUnreadChatrooms = function (filter) {
        var _this = this;
        return function (dispatch, getState) {
            var fetchAndMergeUnreadChatrooms = function () { return __awaiter(_this, void 0, void 0, function () {
                var unreadChatroomIds;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.serverApi.http$fetchUnreadChatroomIds({
                                filter: filter,
                                unreadChatroomLimit: config.maxTrackableUnreads + 1
                            })];
                        case 1:
                            unreadChatroomIds = _a.sent();
                            return [2 /*return*/, mergeUnreads(unreadChatroomIds, getState(), filter)];
                    }
                });
            }); };
            return dispatch({
                type: types.SET_UNREAD_CHATROOMS,
                payload: fetchAndMergeUnreadChatrooms(),
                meta: {
                    filter: filter
                }
            });
        };
    };
    UnreadChatroomCountActions.prototype.resyncRelevantFiltersIfNeeded = function (prevState, state, dispatch) {
        var _this = this;
        return Promise.all(Object
            .keys(prevState.unreadChatroomCount.byFilter)
            .filter(function (filter) { return shouldResync(prevState.unreadChatroomCount.byFilter[filter], state.unreadChatroomCount.byFilter[filter]); })
            .map(function (filter) {
            return dispatch(_this.fetchAndUpdateUnreadChatrooms(parseUnreadFilter(filter)));
        }));
    };
    UnreadChatroomCountActions.prototype.markChatroomAsRead = function (chatroomId) {
        var _this = this;
        return function (dispatch, getState) {
            var prevState = getState();
            dispatch({
                type: types.MARK_CHATROOM_READ,
                payload: chatroomId,
                meta: {
                    chatroom: getState().chatrooms.byId[chatroomId],
                }
            });
            return _this.resyncRelevantFiltersIfNeeded(prevState, getState(), dispatch);
        };
    };
    return UnreadChatroomCountActions;
}());
export default UnreadChatroomCountActions;
